/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OpsRouteImport } from './routes/ops'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SubprocessorsRouteImport } from './routes/subprocessors'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AuditAuditIdRouteImport } from './routes/audit.$auditId'
import { Route as OOrderIdRouteImport } from './routes/o.$orderId'
import { Route as OpsIndexRouteImport } from './routes/ops.index'
import { Route as OpsEmailsRouteImport } from './routes/ops.emails'
import { Route as OpsLibraryRouteImport } from './routes/ops.library'
import { Route as OpsQueueRouteImport } from './routes/ops.queue'
import { Route as OpsReleasesRouteImport } from './routes/ops.releases'
import { Route as OpsSettingsRouteImport } from './routes/ops.settings'
import { Route as OpsSpotChecksRouteImport } from './routes/ops.spot-checks'
import { Route as OpsSummaryRouteImport } from './routes/ops.summary'
import { Route as OpsSupportRouteImport } from './routes/ops.support'
import { Route as OpsLoginRouteImport } from './routes/ops_.login'
import { Route as PreviewTokenRouteImport } from './routes/preview.$token'
import { Route as OOrderIdIndexRouteImport } from './routes/o.$orderId.index'
import { Route as OOrderIdApproveRouteImport } from './routes/o.$orderId.approve'
import { Route as OOrderIdBillingRouteImport } from './routes/o.$orderId.billing'
import { Route as OOrderIdDomainRouteImport } from './routes/o.$orderId.domain'
import { Route as OOrderIdEditorRouteImport } from './routes/o.$orderId.editor'
import { Route as OOrderIdMessagesRouteImport } from './routes/o.$orderId.messages'
import { Route as OOrderIdAdminRouteImport } from './routes/o_.$orderId.admin'
import { Route as OOrderIdEditRouteImport } from './routes/o_.$orderId.edit'
import { Route as OpsOrdersOrderIdRouteImport } from './routes/ops.orders.$orderId'
import { Route as OpsScratchIndexRouteImport } from './routes/ops.scratch.index'
import { Route as OpsScratchProjectIdRouteImport } from './routes/ops.scratch.$projectId'
import { Route as OpsScratchNewRouteImport } from './routes/ops.scratch.new'
import { Route as OpsSupportIndexRouteImport } from './routes/ops.support.index'
import { Route as OpsSupportThreadIdRouteImport } from './routes/ops.support.$threadId'
import { Route as OOrderIdArticlesIndexRouteImport } from './routes/o.$orderId.articles.index'
import { Route as OOrderIdArticlesPostIdRouteImport } from './routes/o_.$orderId.articles.$postId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OpsRoute = OpsRouteImport.update({
  id: '/ops',
  path: '/ops',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const SubprocessorsRoute = SubprocessorsRouteImport.update({
  id: '/subprocessors',
  path: '/subprocessors',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditAuditIdRoute = AuditAuditIdRouteImport.update({
  id: '/audit/$auditId',
  path: '/audit/$auditId',
  getParentRoute: () => rootRouteImport,
} as any)
const OOrderIdRoute = OOrderIdRouteImport.update({
  id: '/o/$orderId',
  path: '/o/$orderId',
  getParentRoute: () => rootRouteImport,
} as any)
const OpsIndexRoute = OpsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OpsRoute,
} as any)
const OpsEmailsRoute = OpsEmailsRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => OpsRoute,
} as any)
const OpsLibraryRoute = OpsLibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => OpsRoute,
} as any)
const OpsQueueRoute = OpsQueueRouteImport.update({
  id: '/queue',
  path: '/queue',
  getParentRoute: () => OpsRoute,
} as any)
const OpsReleasesRoute = OpsReleasesRouteImport.update({
  id: '/releases',
  path: '/releases',
  getParentRoute: () => OpsRoute,
} as any)
const OpsSettingsRoute = OpsSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => OpsRoute,
} as any)
const OpsSpotChecksRoute = OpsSpotChecksRouteImport.update({
  id: '/spot-checks',
  path: '/spot-checks',
  getParentRoute: () => OpsRoute,
} as any)
const OpsSummaryRoute = OpsSummaryRouteImport.update({
  id: '/summary',
  path: '/summary',
  getParentRoute: () => OpsRoute,
} as any)
const OpsSupportRoute = OpsSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => OpsRoute,
} as any)
const OpsLoginRoute = OpsLoginRouteImport.update({
  id: '/ops_/login',
  path: '/ops/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewTokenRoute = PreviewTokenRouteImport.update({
  id: '/preview/$token',
  path: '/preview/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OOrderIdIndexRoute = OOrderIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OOrderIdRoute,
} as any)
const OOrderIdApproveRoute = OOrderIdApproveRouteImport.update({
  id: '/approve',
  path: '/approve',
  getParentRoute: () => OOrderIdRoute,
} as any)
const OOrderIdBillingRoute = OOrderIdBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => OOrderIdRoute,
} as any)
const OOrderIdDomainRoute = OOrderIdDomainRouteImport.update({
  id: '/domain',
  path: '/domain',
  getParentRoute: () => OOrderIdRoute,
} as any)
const OOrderIdEditorRoute = OOrderIdEditorRouteImport.update({
  id: '/editor',
  path: '/editor',
  getParentRoute: () => OOrderIdRoute,
} as any)
const OOrderIdMessagesRoute = OOrderIdMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => OOrderIdRoute,
} as any)
const OOrderIdAdminRoute = OOrderIdAdminRouteImport.update({
  id: '/o_/$orderId/admin',
  path: '/o/$orderId/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const OOrderIdEditRoute = OOrderIdEditRouteImport.update({
  id: '/o_/$orderId/edit',
  path: '/o/$orderId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const OpsOrdersOrderIdRoute = OpsOrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => OpsRoute,
} as any)
const OpsScratchIndexRoute = OpsScratchIndexRouteImport.update({
  id: '/scratch/',
  path: '/scratch/',
  getParentRoute: () => OpsRoute,
} as any)
const OpsScratchProjectIdRoute = OpsScratchProjectIdRouteImport.update({
  id: '/scratch/$projectId',
  path: '/scratch/$projectId',
  getParentRoute: () => OpsRoute,
} as any)
const OpsScratchNewRoute = OpsScratchNewRouteImport.update({
  id: '/scratch/new',
  path: '/scratch/new',
  getParentRoute: () => OpsRoute,
} as any)
const OpsSupportIndexRoute = OpsSupportIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OpsSupportRoute,
} as any)
const OpsSupportThreadIdRoute = OpsSupportThreadIdRouteImport.update({
  id: '/$threadId',
  path: '/$threadId',
  getParentRoute: () => OpsSupportRoute,
} as any)
const OOrderIdArticlesIndexRoute = OOrderIdArticlesIndexRouteImport.update({
  id: '/articles/',
  path: '/articles/',
  getParentRoute: () => OOrderIdRoute,
} as any)
const OOrderIdArticlesPostIdRoute = OOrderIdArticlesPostIdRouteImport.update({
  id: '/o_/$orderId/articles/$postId',
  path: '/o/$orderId/articles/$postId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ops': typeof OpsRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/subprocessors': typeof SubprocessorsRoute
  '/terms': typeof TermsRoute
  '/audit/$auditId': typeof AuditAuditIdRoute
  '/o/$orderId': typeof OOrderIdRouteWithChildren
  '/ops/emails': typeof OpsEmailsRoute
  '/ops/library': typeof OpsLibraryRoute
  '/ops/queue': typeof OpsQueueRoute
  '/ops/releases': typeof OpsReleasesRoute
  '/ops/settings': typeof OpsSettingsRoute
  '/ops/spot-checks': typeof OpsSpotChecksRoute
  '/ops/summary': typeof OpsSummaryRoute
  '/ops/support': typeof OpsSupportRouteWithChildren
  '/ops/login': typeof OpsLoginRoute
  '/preview/$token': typeof PreviewTokenRoute
  '/ops/': typeof OpsIndexRoute
  '/o/$orderId/approve': typeof OOrderIdApproveRoute
  '/o/$orderId/billing': typeof OOrderIdBillingRoute
  '/o/$orderId/domain': typeof OOrderIdDomainRoute
  '/o/$orderId/editor': typeof OOrderIdEditorRoute
  '/o/$orderId/messages': typeof OOrderIdMessagesRoute
  '/o/$orderId/admin': typeof OOrderIdAdminRoute
  '/o/$orderId/edit': typeof OOrderIdEditRoute
  '/ops/orders/$orderId': typeof OpsOrdersOrderIdRoute
  '/ops/scratch/$projectId': typeof OpsScratchProjectIdRoute
  '/ops/scratch/new': typeof OpsScratchNewRoute
  '/ops/support/$threadId': typeof OpsSupportThreadIdRoute
  '/o/$orderId/': typeof OOrderIdIndexRoute
  '/ops/scratch/': typeof OpsScratchIndexRoute
  '/ops/support/': typeof OpsSupportIndexRoute
  '/o/$orderId/articles/$postId': typeof OOrderIdArticlesPostIdRoute
  '/o/$orderId/articles/': typeof OOrderIdArticlesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/subprocessors': typeof SubprocessorsRoute
  '/terms': typeof TermsRoute
  '/audit/$auditId': typeof AuditAuditIdRoute
  '/ops/emails': typeof OpsEmailsRoute
  '/ops/library': typeof OpsLibraryRoute
  '/ops/queue': typeof OpsQueueRoute
  '/ops/releases': typeof OpsReleasesRoute
  '/ops/settings': typeof OpsSettingsRoute
  '/ops/spot-checks': typeof OpsSpotChecksRoute
  '/ops/summary': typeof OpsSummaryRoute
  '/ops/login': typeof OpsLoginRoute
  '/preview/$token': typeof PreviewTokenRoute
  '/ops': typeof OpsIndexRoute
  '/o/$orderId/approve': typeof OOrderIdApproveRoute
  '/o/$orderId/billing': typeof OOrderIdBillingRoute
  '/o/$orderId/domain': typeof OOrderIdDomainRoute
  '/o/$orderId/editor': typeof OOrderIdEditorRoute
  '/o/$orderId/messages': typeof OOrderIdMessagesRoute
  '/o/$orderId/admin': typeof OOrderIdAdminRoute
  '/o/$orderId/edit': typeof OOrderIdEditRoute
  '/ops/orders/$orderId': typeof OpsOrdersOrderIdRoute
  '/ops/scratch/$projectId': typeof OpsScratchProjectIdRoute
  '/ops/scratch/new': typeof OpsScratchNewRoute
  '/ops/support/$threadId': typeof OpsSupportThreadIdRoute
  '/o/$orderId': typeof OOrderIdIndexRoute
  '/ops/scratch': typeof OpsScratchIndexRoute
  '/ops/support': typeof OpsSupportIndexRoute
  '/o/$orderId/articles/$postId': typeof OOrderIdArticlesPostIdRoute
  '/o/$orderId/articles': typeof OOrderIdArticlesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ops': typeof OpsRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/subprocessors': typeof SubprocessorsRoute
  '/terms': typeof TermsRoute
  '/audit/$auditId': typeof AuditAuditIdRoute
  '/o/$orderId': typeof OOrderIdRouteWithChildren
  '/ops/emails': typeof OpsEmailsRoute
  '/ops/library': typeof OpsLibraryRoute
  '/ops/queue': typeof OpsQueueRoute
  '/ops/releases': typeof OpsReleasesRoute
  '/ops/settings': typeof OpsSettingsRoute
  '/ops/spot-checks': typeof OpsSpotChecksRoute
  '/ops/summary': typeof OpsSummaryRoute
  '/ops/support': typeof OpsSupportRouteWithChildren
  '/ops_/login': typeof OpsLoginRoute
  '/preview/$token': typeof PreviewTokenRoute
  '/ops/': typeof OpsIndexRoute
  '/o/$orderId/approve': typeof OOrderIdApproveRoute
  '/o/$orderId/billing': typeof OOrderIdBillingRoute
  '/o/$orderId/domain': typeof OOrderIdDomainRoute
  '/o/$orderId/editor': typeof OOrderIdEditorRoute
  '/o/$orderId/messages': typeof OOrderIdMessagesRoute
  '/o_/$orderId/admin': typeof OOrderIdAdminRoute
  '/o_/$orderId/edit': typeof OOrderIdEditRoute
  '/ops/orders/$orderId': typeof OpsOrdersOrderIdRoute
  '/ops/scratch/$projectId': typeof OpsScratchProjectIdRoute
  '/ops/scratch/new': typeof OpsScratchNewRoute
  '/ops/support/$threadId': typeof OpsSupportThreadIdRoute
  '/o/$orderId/': typeof OOrderIdIndexRoute
  '/ops/scratch/': typeof OpsScratchIndexRoute
  '/ops/support/': typeof OpsSupportIndexRoute
  '/o_/$orderId/articles/$postId': typeof OOrderIdArticlesPostIdRoute
  '/o/$orderId/articles/': typeof OOrderIdArticlesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ops'
    | '/privacy'
    | '/subprocessors'
    | '/terms'
    | '/audit/$auditId'
    | '/o/$orderId'
    | '/ops/emails'
    | '/ops/library'
    | '/ops/queue'
    | '/ops/releases'
    | '/ops/settings'
    | '/ops/spot-checks'
    | '/ops/summary'
    | '/ops/support'
    | '/ops/login'
    | '/preview/$token'
    | '/ops/'
    | '/o/$orderId/approve'
    | '/o/$orderId/billing'
    | '/o/$orderId/domain'
    | '/o/$orderId/editor'
    | '/o/$orderId/messages'
    | '/o/$orderId/admin'
    | '/o/$orderId/edit'
    | '/ops/orders/$orderId'
    | '/ops/scratch/$projectId'
    | '/ops/scratch/new'
    | '/ops/support/$threadId'
    | '/o/$orderId/'
    | '/ops/scratch/'
    | '/ops/support/'
    | '/o/$orderId/articles/$postId'
    | '/o/$orderId/articles/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/privacy'
    | '/subprocessors'
    | '/terms'
    | '/audit/$auditId'
    | '/ops/emails'
    | '/ops/library'
    | '/ops/queue'
    | '/ops/releases'
    | '/ops/settings'
    | '/ops/spot-checks'
    | '/ops/summary'
    | '/ops/login'
    | '/preview/$token'
    | '/ops'
    | '/o/$orderId/approve'
    | '/o/$orderId/billing'
    | '/o/$orderId/domain'
    | '/o/$orderId/editor'
    | '/o/$orderId/messages'
    | '/o/$orderId/admin'
    | '/o/$orderId/edit'
    | '/ops/orders/$orderId'
    | '/ops/scratch/$projectId'
    | '/ops/scratch/new'
    | '/ops/support/$threadId'
    | '/o/$orderId'
    | '/ops/scratch'
    | '/ops/support'
    | '/o/$orderId/articles/$postId'
    | '/o/$orderId/articles'
  id:
    | '__root__'
    | '/'
    | '/ops'
    | '/privacy'
    | '/subprocessors'
    | '/terms'
    | '/audit/$auditId'
    | '/o/$orderId'
    | '/ops/emails'
    | '/ops/library'
    | '/ops/queue'
    | '/ops/releases'
    | '/ops/settings'
    | '/ops/spot-checks'
    | '/ops/summary'
    | '/ops/support'
    | '/ops_/login'
    | '/preview/$token'
    | '/ops/'
    | '/o/$orderId/approve'
    | '/o/$orderId/billing'
    | '/o/$orderId/domain'
    | '/o/$orderId/editor'
    | '/o/$orderId/messages'
    | '/o_/$orderId/admin'
    | '/o_/$orderId/edit'
    | '/ops/orders/$orderId'
    | '/ops/scratch/$projectId'
    | '/ops/scratch/new'
    | '/ops/support/$threadId'
    | '/o/$orderId/'
    | '/ops/scratch/'
    | '/ops/support/'
    | '/o_/$orderId/articles/$postId'
    | '/o/$orderId/articles/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OpsRoute: typeof OpsRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  SubprocessorsRoute: typeof SubprocessorsRoute
  TermsRoute: typeof TermsRoute
  AuditAuditIdRoute: typeof AuditAuditIdRoute
  OOrderIdRoute: typeof OOrderIdRouteWithChildren
  OpsLoginRoute: typeof OpsLoginRoute
  PreviewTokenRoute: typeof PreviewTokenRoute
  OOrderIdAdminRoute: typeof OOrderIdAdminRoute
  OOrderIdEditRoute: typeof OOrderIdEditRoute
  OOrderIdArticlesPostIdRoute: typeof OOrderIdArticlesPostIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ops': {
      id: '/ops'
      path: '/ops'
      fullPath: '/ops'
      preLoaderRoute: typeof OpsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subprocessors': {
      id: '/subprocessors'
      path: '/subprocessors'
      fullPath: '/subprocessors'
      preLoaderRoute: typeof SubprocessorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit/$auditId': {
      id: '/audit/$auditId'
      path: '/audit/$auditId'
      fullPath: '/audit/$auditId'
      preLoaderRoute: typeof AuditAuditIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$orderId': {
      id: '/o/$orderId'
      path: '/o/$orderId'
      fullPath: '/o/$orderId'
      preLoaderRoute: typeof OOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ops/': {
      id: '/ops/'
      path: '/'
      fullPath: '/ops/'
      preLoaderRoute: typeof OpsIndexRouteImport
      parentRoute: typeof OpsRoute
    }
    '/ops/emails': {
      id: '/ops/emails'
      path: '/emails'
      fullPath: '/ops/emails'
      preLoaderRoute: typeof OpsEmailsRouteImport
      parentRoute: typeof OpsRoute
    }
    '/ops/library': {
      id: '/ops/library'
      path: '/library'
      fullPath: '/ops/library'
      preLoaderRoute: typeof OpsLibraryRouteImport
      parentRoute: typeof OpsRoute
    }
    '/ops/queue': {
      id: '/ops/queue'
      path: '/queue'
      fullPath: '/ops/queue'
      preLoaderRoute: typeof OpsQueueRouteImport
      parentRoute: typeof OpsRoute
    }
    '/ops/releases': {
      id: '/ops/releases'
      path: '/releases'
      fullPath: '/ops/releases'
      preLoaderRoute: typeof OpsReleasesRouteImport
      parentRoute: typeof OpsRoute
    }
    '/ops/settings': {
      id: '/ops/settings'
      path: '/settings'
      fullPath: '/ops/settings'
      preLoaderRoute: typeof OpsSettingsRouteImport
      parentRoute: typeof OpsRoute
    }
    '/ops/spot-checks': {
      id: '/ops/spot-checks'
      path: '/spot-checks'
      fullPath: '/ops/spot-checks'
      preLoaderRoute: typeof OpsSpotChecksRouteImport
      parentRoute: typeof OpsRoute
    }
    '/ops/summary': {
      id: '/ops/summary'
      path: '/summary'
      fullPath: '/ops/summary'
      preLoaderRoute: typeof OpsSummaryRouteImport
      parentRoute: typeof OpsRoute
    }
    '/ops/support': {
      id: '/ops/support'
      path: '/support'
      fullPath: '/ops/support'
      preLoaderRoute: typeof OpsSupportRouteImport
      parentRoute: typeof OpsRoute
    }
    '/ops_/login': {
      id: '/ops_/login'
      path: '/ops/login'
      fullPath: '/ops/login'
      preLoaderRoute: typeof OpsLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/$token': {
      id: '/preview/$token'
      path: '/preview/$token'
      fullPath: '/preview/$token'
      preLoaderRoute: typeof PreviewTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$orderId/': {
      id: '/o/$orderId/'
      path: '/'
      fullPath: '/o/$orderId/'
      preLoaderRoute: typeof OOrderIdIndexRouteImport
      parentRoute: typeof OOrderIdRoute
    }
    '/o/$orderId/approve': {
      id: '/o/$orderId/approve'
      path: '/approve'
      fullPath: '/o/$orderId/approve'
      preLoaderRoute: typeof OOrderIdApproveRouteImport
      parentRoute: typeof OOrderIdRoute
    }
    '/o/$orderId/billing': {
      id: '/o/$orderId/billing'
      path: '/billing'
      fullPath: '/o/$orderId/billing'
      preLoaderRoute: typeof OOrderIdBillingRouteImport
      parentRoute: typeof OOrderIdRoute
    }
    '/o/$orderId/domain': {
      id: '/o/$orderId/domain'
      path: '/domain'
      fullPath: '/o/$orderId/domain'
      preLoaderRoute: typeof OOrderIdDomainRouteImport
      parentRoute: typeof OOrderIdRoute
    }
    '/o/$orderId/editor': {
      id: '/o/$orderId/editor'
      path: '/editor'
      fullPath: '/o/$orderId/editor'
      preLoaderRoute: typeof OOrderIdEditorRouteImport
      parentRoute: typeof OOrderIdRoute
    }
    '/o/$orderId/messages': {
      id: '/o/$orderId/messages'
      path: '/messages'
      fullPath: '/o/$orderId/messages'
      preLoaderRoute: typeof OOrderIdMessagesRouteImport
      parentRoute: typeof OOrderIdRoute
    }
    '/o_/$orderId/admin': {
      id: '/o_/$orderId/admin'
      path: '/o/$orderId/admin'
      fullPath: '/o/$orderId/admin'
      preLoaderRoute: typeof OOrderIdAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o_/$orderId/edit': {
      id: '/o_/$orderId/edit'
      path: '/o/$orderId/edit'
      fullPath: '/o/$orderId/edit'
      preLoaderRoute: typeof OOrderIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ops/orders/$orderId': {
      id: '/ops/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/ops/orders/$orderId'
      preLoaderRoute: typeof OpsOrdersOrderIdRouteImport
      parentRoute: typeof OpsRoute
    }
    '/ops/scratch/': {
      id: '/ops/scratch/'
      path: '/scratch'
      fullPath: '/ops/scratch/'
      preLoaderRoute: typeof OpsScratchIndexRouteImport
      parentRoute: typeof OpsRoute
    }
    '/ops/scratch/$projectId': {
      id: '/ops/scratch/$projectId'
      path: '/scratch/$projectId'
      fullPath: '/ops/scratch/$projectId'
      preLoaderRoute: typeof OpsScratchProjectIdRouteImport
      parentRoute: typeof OpsRoute
    }
    '/ops/scratch/new': {
      id: '/ops/scratch/new'
      path: '/scratch/new'
      fullPath: '/ops/scratch/new'
      preLoaderRoute: typeof OpsScratchNewRouteImport
      parentRoute: typeof OpsRoute
    }
    '/ops/support/': {
      id: '/ops/support/'
      path: '/'
      fullPath: '/ops/support/'
      preLoaderRoute: typeof OpsSupportIndexRouteImport
      parentRoute: typeof OpsSupportRoute
    }
    '/ops/support/$threadId': {
      id: '/ops/support/$threadId'
      path: '/$threadId'
      fullPath: '/ops/support/$threadId'
      preLoaderRoute: typeof OpsSupportThreadIdRouteImport
      parentRoute: typeof OpsSupportRoute
    }
    '/o/$orderId/articles/': {
      id: '/o/$orderId/articles/'
      path: '/articles'
      fullPath: '/o/$orderId/articles/'
      preLoaderRoute: typeof OOrderIdArticlesIndexRouteImport
      parentRoute: typeof OOrderIdRoute
    }
    '/o_/$orderId/articles/$postId': {
      id: '/o_/$orderId/articles/$postId'
      path: '/o/$orderId/articles/$postId'
      fullPath: '/o/$orderId/articles/$postId'
      preLoaderRoute: typeof OOrderIdArticlesPostIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface OpsSupportRouteChildren {
  OpsSupportThreadIdRoute: typeof OpsSupportThreadIdRoute
  OpsSupportIndexRoute: typeof OpsSupportIndexRoute
}

const OpsSupportRouteChildren: OpsSupportRouteChildren = {
  OpsSupportThreadIdRoute: OpsSupportThreadIdRoute,
  OpsSupportIndexRoute: OpsSupportIndexRoute,
}

const OpsSupportRouteWithChildren = OpsSupportRoute._addFileChildren(
  OpsSupportRouteChildren,
)

interface OpsRouteChildren {
  OpsEmailsRoute: typeof OpsEmailsRoute
  OpsLibraryRoute: typeof OpsLibraryRoute
  OpsQueueRoute: typeof OpsQueueRoute
  OpsReleasesRoute: typeof OpsReleasesRoute
  OpsSettingsRoute: typeof OpsSettingsRoute
  OpsSpotChecksRoute: typeof OpsSpotChecksRoute
  OpsSummaryRoute: typeof OpsSummaryRoute
  OpsSupportRoute: typeof OpsSupportRouteWithChildren
  OpsIndexRoute: typeof OpsIndexRoute
  OpsOrdersOrderIdRoute: typeof OpsOrdersOrderIdRoute
  OpsScratchProjectIdRoute: typeof OpsScratchProjectIdRoute
  OpsScratchNewRoute: typeof OpsScratchNewRoute
  OpsScratchIndexRoute: typeof OpsScratchIndexRoute
}

const OpsRouteChildren: OpsRouteChildren = {
  OpsEmailsRoute: OpsEmailsRoute,
  OpsLibraryRoute: OpsLibraryRoute,
  OpsQueueRoute: OpsQueueRoute,
  OpsReleasesRoute: OpsReleasesRoute,
  OpsSettingsRoute: OpsSettingsRoute,
  OpsSpotChecksRoute: OpsSpotChecksRoute,
  OpsSummaryRoute: OpsSummaryRoute,
  OpsSupportRoute: OpsSupportRouteWithChildren,
  OpsIndexRoute: OpsIndexRoute,
  OpsOrdersOrderIdRoute: OpsOrdersOrderIdRoute,
  OpsScratchProjectIdRoute: OpsScratchProjectIdRoute,
  OpsScratchNewRoute: OpsScratchNewRoute,
  OpsScratchIndexRoute: OpsScratchIndexRoute,
}

const OpsRouteWithChildren = OpsRoute._addFileChildren(OpsRouteChildren)

interface OOrderIdRouteChildren {
  OOrderIdApproveRoute: typeof OOrderIdApproveRoute
  OOrderIdBillingRoute: typeof OOrderIdBillingRoute
  OOrderIdDomainRoute: typeof OOrderIdDomainRoute
  OOrderIdEditorRoute: typeof OOrderIdEditorRoute
  OOrderIdMessagesRoute: typeof OOrderIdMessagesRoute
  OOrderIdIndexRoute: typeof OOrderIdIndexRoute
  OOrderIdArticlesIndexRoute: typeof OOrderIdArticlesIndexRoute
}

const OOrderIdRouteChildren: OOrderIdRouteChildren = {
  OOrderIdApproveRoute: OOrderIdApproveRoute,
  OOrderIdBillingRoute: OOrderIdBillingRoute,
  OOrderIdDomainRoute: OOrderIdDomainRoute,
  OOrderIdEditorRoute: OOrderIdEditorRoute,
  OOrderIdMessagesRoute: OOrderIdMessagesRoute,
  OOrderIdIndexRoute: OOrderIdIndexRoute,
  OOrderIdArticlesIndexRoute: OOrderIdArticlesIndexRoute,
}

const OOrderIdRouteWithChildren = OOrderIdRoute._addFileChildren(
  OOrderIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OpsRoute: OpsRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  SubprocessorsRoute: SubprocessorsRoute,
  TermsRoute: TermsRoute,
  AuditAuditIdRoute: AuditAuditIdRoute,
  OOrderIdRoute: OOrderIdRouteWithChildren,
  OpsLoginRoute: OpsLoginRoute,
  PreviewTokenRoute: PreviewTokenRoute,
  OOrderIdAdminRoute: OOrderIdAdminRoute,
  OOrderIdEditRoute: OOrderIdEditRoute,
  OOrderIdArticlesPostIdRoute: OOrderIdArticlesPostIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
